// use this to make typescript check if a switch statement is exhaustive or not

export class UnreachableCaseError extends Error {
    constructor(val: string) {
        super(`Unreachable case: ${val}`);
    }
}
